/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconOpensource = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      viewBox="0 0 26 26"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 26px;
      `}
      {...props}
    >
      <g fill={fill} fillRule="evenodd">
        <g transform="translate(1 1)">
          <circle cx={12} cy={12} r={12} />
          <path
            stroke={stroke}
            strokeWidth={weight === "normal" ? 1.5 : 1}
            d="M12 0c6.627 0 12 5.372 12 11.999 0 5.052-3.122 9.374-7.542 11.144l-2.674-6.687a4.801 4.801 0 1 0-3.567 0h0l-2.674 6.687C3.123 21.374 0 17.051 0 12 0 5.372 5.373 0 12 0z"
          />
        </g>
        <path
          stroke={stroke}
          strokeLinecap="round"
          strokeWidth={weight === "normal" ? 1.5 : 1}
          d="M18.94 18.94a8.4 8.4 0 1 0-11.88 0"
        />
      </g>
    </svg>
  ),
);
